import {batch, effect, signal} from "@preact/signals-react";

import {isLoadingCommonFilters} from "@signals";

export const isBannersPercentageEmpty = signal(false)
export const isBannersPercentageHighLevelLoading = signal(false)
export const isBannersPercentageDynamicLoading = signal(false)
export const isBannersPercentageReachLoading = signal(false)
export const isBannersPercentageContentLoading = signal(false)

// Functions
export const resetBannersPercentageSignals = () => batch(() => {
    isBannersPercentageHighLevelLoading.value = false
    isBannersPercentageDynamicLoading.value = false
    isBannersPercentageReachLoading.value = false
    isBannersPercentageContentLoading.value = false
    isBannersPercentageEmpty.value = false
})

// Effects
effect(() => {
    const isDashboardLoading = isBannersPercentageHighLevelLoading.value || isBannersPercentageDynamicLoading.value || isBannersPercentageReachLoading.value

    if (isDashboardLoading && !isBannersPercentageContentLoading.value)
        isBannersPercentageContentLoading.value = true

    if (!isDashboardLoading && isBannersPercentageContentLoading.value) {
        isBannersPercentageContentLoading.value = false
        isLoadingCommonFilters.value = false
    }
})